import {
  CreateCustomFieldPayload,
  CustomField,
  CustomFieldGroup,
  CustomFieldValue,
  OrderCustomField,
  UpdateCustomFieldPayload,
} from "@web-app/types";
import http from "@web-app/utils/http";

export const list = async (workspaceId: string, active: boolean = false) => {
  return http
    .get<CustomField[]>(
      `/customFields${active ? "/active" : ""}?workspaceId=` + workspaceId,
    )
    .then((response) => response.data)
    .then((data) => {
      const sortedCustomFields = (data || []).sort(
        (a: CustomField, b: CustomField) => a.name.localeCompare(b.name),
      );

      return sortedCustomFields;
    });
};

export const groupList = async () => {
  return http
    .get<CustomFieldGroup[]>("/customFieldGroups")
    .then((response) => response.data || []);
};

export const groupListByIds = async (ids: string[]) => {
  return http
    .get<CustomFieldGroup[]>(`/customFieldGroups/by-ids?ids=${ids.join(",")}`)
    .then((response) => response.data || []);
};

// Public API - doesn't require authentication
export const publicList = async (
  workspaceId: string,
  active: boolean = false,
) => {
  return http
    .get<CustomField[]>(
      `/public/workspaces/${workspaceId}/customFields${active ? "/active" : ""}`,
    )
    .then((response) => response.data)
    .then((data) => {
      const sortedCustomFields = (data || []).sort(
        (a: CustomField, b: CustomField) => a.name.localeCompare(b.name),
      );

      return sortedCustomFields;
    });
};

// Public API - doesn't require authentication
export const publicGroupList = async (workspaceId: string) => {
  return http
    .get<CustomFieldGroup[]>(
      `/public/workspaces/${workspaceId}/customFieldGroups`,
    )
    .then((response) => response.data || []);
};

export const create = async (payload: CreateCustomFieldPayload) => {
  return http
    .post<CustomField>("/customFields", payload)
    .then((response) => response.data);
};

export const update = async (
  payload: Partial<UpdateCustomFieldPayload>,
  customFieldId: string,
) => {
  return http
    .patch<CustomField>("/customFields/" + customFieldId, payload)
    .then((response) => response.data);
};

export const updateOrderCustomFieldValue = async (
  payload: { customFieldValues: CustomFieldValue[] },
  entityId: string,
  fieldId: string,
) => {
  return http
    .patch<OrderCustomField>(
      "/orders/" + entityId + "/customFields/" + fieldId,
      payload,
    )
    .then((response) => response.data);
};

export const remove = async (customFieldId: string) => {
  return http
    .delete(`/workspace/customFields/${customFieldId}`)
    .then((response) => response.data);
};
